import React, { useEffect, useState } from 'react'
import { Paper, Typography, TextField, Grid, Button, Box } from '@material-ui/core'

import firebase from '../../firebase'
import Header from '../Header';


export default function Manager() {
    const db = firebase.firestore();
    const [data, setData] = useState([]);
    const [name, setName] = useState('');
    const [pass, setPass] = useState('');
    const [phone, setNumber] = useState(0);

    const onCreate = () => {
        const db = firebase.firestore();
        let countryCode = '+237'
        let email = countryCode + phone + '@domainName.com';

        db.collection('ManagersData').doc(email).set({ name, phone, id: email, pass });

        setName('');
        setNumber(0);
        setPass('')
    }

    const onRemove = (id) => {
        const db = firebase.firestore();

        db.collection('ManagersData').doc(id).delete().then(res => {
            console.log(res)
        })
    }

    useEffect(() => {
        return db.collection('ManagersData').onSnapshot((snapshot) => {
            const data = [];
            snapshot.forEach(doc => {
                data.push(({ ...doc.data(), id: doc.id }))
            })
            console.log(data)
            setData(data)
        });
    }, [])
    return (
        <div>
            <Header />
            <div style={{ marginLeft: 20, marginBottom: 20 }}>
                <h2>Add manager data</h2>

                <Grid container spacing={4}>
                    <Grid item xs={12} md={2}>
                        <TextField
                            id="standard-helperText"
                            label="Name"
                            required
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            autoComplete='off'
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <TextField
                            id="standard-helperText"
                            label="Phone No"
                            required
                            type="number"
                            value={phone}
                            onChange={(e) => setNumber(parseInt(e.target.value))}
                            autoComplete='off'
                        />
                    </Grid>
                    {/* <Grid item xs={12} md={2}>
                            <TextField
                                id="standard-helperText"
                                label="Gender"
                                required
                                value={gender}
                                onChange={(e) => setGender(e.target.value)}
                                autoComplete='off'
                            />
                        </Grid> */}
                    <Grid item xs={12} md={2}>
                        <TextField
                            id="standard-helperText"
                            label="Password"
                            required
                            value={pass}
                            onChange={(e) => setPass(e.target.value)}
                            autoComplete='off'
                        />
                    </Grid>
                    <Grid item xs={4} md={2} >
                        <Button
                            onClick={onCreate}
                            style={{ marginTop: 10 }} variant="contained">Add</Button>
                    </Grid>

                </Grid>
            </div>
            <Grid container
                direction="row"
                // justify="center"
                alignItems="center"
                style={{ marginLeft: 10 }}
            >
                {data.map(item => (

                    <Box
                        m={1}
                        p={1}
                        key={item.id}
                    >
                        <Paper style={{ padding: 10 }}>
                            <Typography variant="h6" style={{
                                marginBottom: 10,
                                fontSize: 23
                            }} color="textSecondary">
                                {item.name}
                            </Typography>
                            <Typography style={{
                                fontSize: 15
                            }}>
                                Phone : {item.phone}
                            </Typography>
                            <Button
                                onClick={() => onRemove(item.id)}
                                style={{ marginTop: 10 }} variant="contained">Remove</Button>
                        </Paper>
                    </Box>
                ))}
            </Grid>
        </div>
    )
}
